import { profileLinks } from 'components/ProfileLayout';
import Link from 'next/link';
import { useRouter } from 'next/router';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export default function ProfileTabbedNavigation() {
    const { pathname, push } = useRouter();

    const onLinkChange = (e) => {
        const selectedLink = profileLinks.find((link) => link.label === e.target.value);
        push(selectedLink.href);
    };

    return (
        <div>
            <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                    Select a tab
                </label>
                {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                <select
                    id="tabs"
                    name="tabs"
                    onChange={onLinkChange}
                    className="block w-full rounded-md border-gray-300 focus:border-brand focus:ring-brand"
                    defaultValue={profileLinks.find((link) => link.href === pathname).label}
                >
                    {profileLinks.map((link) => (
                        <option key={link.label}>{link.label}</option>
                    ))}
                </select>
            </div>
            <div className="hidden sm:block">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex space-x-6" aria-label="Tabs">
                        {profileLinks.map((link) => {
                            const isActive = pathname === link.href;
                            return (
                                <Link
                                    key={link.label}
                                    href={link.href}
                                    className={classNames(
                                        isActive
                                            ? 'border-brand text-brand'
                                            : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-700',
                                        'group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium'
                                    )}
                                    aria-current={isActive ? 'page' : undefined}
                                >
                                    <link.icon
                                        className={classNames(
                                            isActive ? 'text-brand' : 'text-gray-500 group-hover:text-gray-500',
                                            '-ml-0.5 mr-2 h-6 w-6'
                                        )}
                                        aria-hidden="true"
                                    />
                                    <span>{link.label}</span>
                                </Link>
                            );
                        })}
                    </nav>
                </div>
            </div>
        </div>
    );
}
